import axios from "../axios";
import auth from "./auth";

// Salle de cours (Zoom) : tout vient du serveur, jamais du navigateur
const classroom = {
  // Jeton, nom de la salle, mot de passe et statut du cours (prof ou élève du cours uniquement)
  getZoomCredentials(classId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`classes/${encodeURIComponent(classId)}/zoom`)
        .then(({ data }) => resolve(data))
        .catch((err) => {
          reject(err);
          err?.response?.status === 401 && auth?.destroyToken();
        });
    });
  },
  // 🔎 Échec de la salle (tour 65, A9) : gardé et journalisé par l'API, rien de personnel. Jamais d'erreur
  // pour la salle : si l'envoi échoue, tant pis
  reportZoomError(classId, report) {
    return axios
      .post(`classes/${encodeURIComponent(classId)}/zoom-error`, report)
      .then(() => true)
      .catch(() => false);
  },
  // « Annuler, problème technique » (prof du cours) : l'élève est remboursé
  technicalCancel(classId) {
    return new Promise((resolve, reject) => {
      axios
        .post(`classes/${encodeURIComponent(classId)}/technical-cancel`)
        .then(({ data }) => resolve(data))
        .catch((err) => {
          reject(err);
          err?.response?.status === 401 && auth?.destroyToken();
        });
    });
  },
};

export default classroom;
